// Actions
export const ADD_COLLECTION = 'candidateExperience/entities/staticJobRoles/ADD_COLLECTION'
export const ADD_ITEM = 'candidateExperience/entities/staticJobRoles/ADD_ITEM'

// Action Creators
export const addCollection = collection => ({
  type: ADD_COLLECTION,
  payload: collection.map(item => addItem(item.id, item)),
})

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

// Reducers
const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_COLLECTION:
      return {
        ...state,
        ...payload.reduce((map, item) => {
          map[item.meta.id] = entity(state[item.meta.id], {
            type: item.type,
            payload: item.payload,
          })
          return map
        }, {}),
      }

    case ADD_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getStaticJobRoleMap = state => state.entities.staticJobRoles || defaultMap
export const getStaticJobRoleItem = (state, id) => state.entities.staticJobRoles[id] || defaultEntity
